import _slicedToArray from "/opt/build/repo/results/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useLayoutEffect as e } from "@radix-ui/react-use-layout-effect";
import { useComposedRefs as n } from "@radix-ui/react-compose-refs";
import * as t from "react";
export var Presence = function Presence(u) {
  var o = u.present,
      i = u.children,
      s = function (n) {
    var _t$useState = t.useState(),
        _t$useState2 = _slicedToArray(_t$useState, 2),
        u = _t$useState2[0],
        o = _t$useState2[1],
        i = t.useRef({}),
        s = t.useRef(n),
        c = t.useRef("none"),
        a = n ? "mounted" : "unmounted",
        _ref = function (e, n) {
      return t.useReducer(function (e, t) {
        var r = n[e][t];
        return null != r ? r : e;
      }, e);
    }(a, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    }),
        _ref2 = _slicedToArray(_ref, 2),
        d = _ref2[0],
        m = _ref2[1];

    return t.useEffect(function () {
      var e = r(i.current);
      c.current = "mounted" === d ? e : "none";
    }, [d]), e(function () {
      var e = i.current,
          t = s.current;

      if (t !== n) {
        var _u = c.current,
            _o = r(e);

        if (n) m("MOUNT");else if ("none" === _o || "none" === (null == e ? void 0 : e.display)) m("UNMOUNT");else {
          var _e = _u !== _o;

          m(t && _e ? "ANIMATION_OUT" : "UNMOUNT");
        }
        s.current = n;
      }
    }, [n, m]), e(function () {
      if (u) {
        var _e2 = function _e2(e) {
          var n = r(i.current).includes(e.animationName);
          e.target === u && n && m("ANIMATION_END");
        },
            _n = function _n(e) {
          e.target === u && (c.current = r(i.current));
        };

        return u.addEventListener("animationstart", _n), u.addEventListener("animationcancel", _e2), u.addEventListener("animationend", _e2), function () {
          u.removeEventListener("animationstart", _n), u.removeEventListener("animationcancel", _e2), u.removeEventListener("animationend", _e2);
        };
      }
    }, [u, m]), {
      isPresent: ["mounted", "unmountSuspended"].includes(d),
      ref: t.useCallback(function (e) {
        e && (i.current = getComputedStyle(e)), o(e);
      }, [])
    };
  }(o),
      c = "function" == typeof i ? i({
    present: s.isPresent
  }) : t.Children.only(i),
      a = n(s.ref, c.ref);

  return "function" == typeof i || s.isPresent ? /*#__PURE__*/t.cloneElement(c, {
    ref: a
  }) : null;
};

function r(e) {
  return (null == e ? void 0 : e.animationName) || "none";
}

Presence.displayName = "Presence";